export const APP_MODE = "web";
export const APP_VERSION = "1.232";
export const baseURL = 'https://pwa.luxintech.com/';
export const apiTimeOut = 10000;
export const alexaUUID = 153391688;
export const nestUUID = 153391687;
export const alexaBaseURL = "https://ava.luxintech.com/";
export const nestBaseURL = "https://nva.luxintech.com/";
export const googleAuth2ClientId = "727056523290-2a5kfi5tgotkbedafqidknoah0lukk2e.apps.googleusercontent.com";
export const UPDATE_HUB_NODE_STATUS_INTERVAL_TIME = 5000;
export const updateHubNodeStatusIntervalTime = 5000;
export const DEFAULT_HUB_ADDRESS_PREFIX = 'luxin-';
export const HUB_CONNECTION_STATUS_DISCONNECTED = 0;
export const HUB_CONNECTION_STATUS_CONNECTING = 1;
export const HUB_CONNECTION_STATUS_CONNECTED = 2;
export const EVENT_DIRECTION_FALLING = 0;
export const EVENT_DIRECTION_RISING = 1;
export const EVENT_DIRECTION_ANY = 2;
export const EVENT_DIRECTION_TOGGLE = 3;
export const ACTION_TYPE_SET = 0;
export const ACTION_TYPE_INCREMENT = 1;
export const ACTION_TYPE_TOGGLE = 2;
export const CLEAR_PENDING_ACTIONS_ON_OUTPUT1 = 24688;
export const CLEAR_PENDING_ACTIONS_ON_OUTPUT2 = 24689
export const RELATION_EQUAL = 0;
export const RELATION_UNEQUAL = 1;
export const RELATION_LESS_THAN = 2;
export const RELATION_GREATER_THAN = 3;
export const RELATION_LESS_THAN_EQUAL = 4;
export const RELATION_GREATER_THAN_EQUAL = 5;
export const RGBW_ANIMATION_NONE = 0;
export const RGBW_ANIMATION_RANDOM = 1;
export const RGBW_ANIMATION_HUE_CIRCLE = 2;
export const PLUG_OUTPUT_INITIAL_OFF = 0;
export const PLUG_OUTPUT_INITIAL_ON = 1;
export const PLUG_OUTPUT_INITIAL_LAST_STATE = 6;
export const MAX_LORA_PACKET_SIZE = 230;
export const MAX_IMITATOR_PACKET_SIZE = 510;
export const TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX = 0x01;
export const SCHEDULE_EVENT_ID_PREFIX = 0x02;
export const NOTIFICATION_EVENT_ID_PREFIX = 0x03;
export const INPUT_CONNECT_VALUE = 0;
export const INPUT_DISCONNECT_VALUE = 1;
export const TEMPERATURE_AUTOMATION_COOL_SETPOINT = 190;
export const TEMPERATURE_AUTOMATION_HEAT_SETPOINT = 270;
export const HUMIDITY_AUTOMATION_SETPOINT = 30;
export const TEMPERATURE_AUTOMATION_OFFSET = 5;
export const HUMIDITY_AUTOMATION_OFFSET = 1;
export const SCHEDULE_REPEAT_MASK_WEEKDAYS = [
  0x02,//Sun
  0x04,//Mon
  0x08,//Tue
  0x10,//Wed
  0x20,//Thu
  0x40,//Fri
  0x01,//Sat
];
export const SCHEDULE_REPEAT_MASK_OCCATIONAL = 0x80;